import { Platform, PlatformIOSStatic } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";

export function usePlatformSafeAreaInsets(bottomOffset = 40) {
  const insets = useSafeAreaInsets();
  let bottom = insets.bottom;

  if (Platform.OS === "ios" && (Platform as PlatformIOSStatic).isPad) {
    bottom = bottom + bottomOffset;
  }

  return { ...insets, bottom };
}
